import React, { Component } from 'react';
import NetworkingDelegates from './NetworkingDelegates';
import NetworkingSocialMedia from './NetworkingSocialMedia';
import NetworkingVideoWall from './NetworkingVideoWall';
import axios from 'axios'
import configData from '../../../config.json';
import AuthContext from '../../../context/auth-context';
import { withTranslation } from 'react-i18next'
import io from "socket.io-client";
import WithPermission from '../../../hoc/WithPermission'
import Video from '../../../containers/Assistant/AssistantVideo';
import ContactRequest from '../../../containers/Congress/IndustriaStand/ContactRequest'

class Networking extends Component {

    state = {
        backgroundImage: "https://www.emma.events/static/virtualvenue/cnp2020/lobby-scientific-cnp2020.jpg",
        page: "delegates",
        persons: [],
        access: ["10","54434","144186","144402","144403","44331","99999999000050","4964", "30437", "95221", "67618", "91954", "106504", "95185", "71936", "115175", "43327", "95206", "96468", "115284", "83253", "48283", "95322", "47300", "77314", "82874", "51340", "115348", "100366", "82987", "94853", "99202", "77259", "115385", "85575", "50040", "85041", "48371", "95052", "115411", "48373", "105525", "115434", "115438", "115452", "71324", "90923", "50788", "83905", "70145", "106399", "52462", "80908", "115525", "53271", "115535", "83249", "42660", "77516", "95316", "49640", "95317", "43521", "50138", "42662", "48040", "79257", "49020", "84067", "42665", "95320", "70485", "42739", "73106", "47279", "50038", "46936", "73664", "49042", "52914", "42672", "43326", "77560", "50316", "44464", "115542", "95330", "42683", "65369", "88578", "95333", "85317", "42968", "48797", "43325", "43316", "74787", "42677", "79219", "43301", "62668", "43328", "40280", "44123", "42682", "69271", "44153", "48046", "105404", "99544", "95058", "42679", "42685", "42934", "49246", "46996", "42686", "78910", "50402", "48047", "50365", "95024", "95351", "51352", "42697", "42698", "43322", "49538", "83123", "70049", "65377", "63168", "83265", "82953", "53313", "71770", "43011", "94634", "96482", "69460", "106956", "49011", "88588", "44074", "60298", "105225", "46157", "48234", "116577", "94992", "89396", "72867", "94707", "69770", "116658", "61101", "116673", "83225", "116738", "83255", "70956", "83001", "55928", "116767", "48042", "84099", "95054", "94631", "47290", "116806", "116808", "106470", "49051", "79514", "51002", "43512", "91607", "62495", "71807", "83371", "48044", "105581", "79693", "116943", "42331", "73666", "50693", "79132", "105421", "51341", "73095", "48763", "71514", "40491", "85895", "105829", "105241", "79498", "83432", "62977", "90306", "86474", "88625", "92087", "82344", "94752", "69412", "70147", "46689", "61982", "65841", "95049", "95023", "94030", "79459", "49732", "42908", "69445", "50863", "81783", "120835", "50716", "123784", "123785", "47286", "123941", "71296", "124666", "124946", "42676", "124987", "124988", "83187", "50629", "124993", "43315", "82910", "62492", "106243", "54382", "125332", "125337", "55380", "125340", "125343", "42694", "71238", "96019", "79575", "125415", "50118", "125687", "82990", "125698", "71898", "107308", "125823", "42671", "42700", "42689", "42696", "42690", "53602", "73500", "125831", "50302", "47034", "126139", "126161", "126164", "111896", "100930", "105414", "44156", "77044", "72026", "126841", "126846", "51342", "74206", "126887", "94835", "106469", "62708", "70755", "102041", "55225", "79659", "127590", "55371", "94744", "49847", "62140", "105726", "50694", "128951", "132966", "50043", "50135", "55451", "42666", "42692", "42917", "42960", "43329", "43515", "44120", "44467", "45037", "46930", "47666", "47868", "48043", "48142", "48304", "40391", "49659", "49661", "49687", "49723", "49894", "49999", "50081", "50119", "50192", "50337", "50686", "50761", "50775", "50858", "50864", "50866", "50958", "50960", "50965", "50966", "50975", "51004", "51013", "51039", "51040", "51077", "51325", "51328", "51343", "53195", "53880", "53933", "54366", "54373", "55313", "55342", "55355", "55363", "55378", "55388", "55473", "62486", "62499", "62561", "64880", "67043", "67289", "69148", "69163", "69497", "69966", "70221", "70678", "70780", "61950", "70825", "70969", "71039", "71142", "71155", "71242", "71524", "71557", "71685", "71764", "71772", "71894", "71943", "72046", "72053", "72126", "72130", "72228", "72509", "72664", "72929", "74203", "74743", "74806", "79814", "81065", "81797", "82219", "83105", "79320", "95334", "83155", "83226", "83257", "83267", "83272", "83534", "83918", "84068", "84983", "85086", "85304", "85621", "85712", "85972", "85983", "86087", "86130", "88315", "89111", "89163", "89353", "89372", "89373", "93574", "93824", "94848", "95027", "95102", "95186", "95331", "100746", "102585", "54293", "105402", "105412", "105585", "105846", "96368", "106263", "106590", "79509", "106849", "106933", "107059", "42182", "107148", "107172", "62483", "66", "107314", "3113", "101380", "111897", "115037", "137813", "137833", "138045", "138084", "139994", "140034", "140091", "140092", "140095", "140096", "120961", "81385", "77237", "140267", "140345", "114008", "122524", "140364", "140408", "121172", "122158", "123314", "140519", "140689", "55285", "124150", "141137", "141658", "141892", "141991", "143111", "143286", "143290", "143296", "143306", "143308", "143310", "138134", "143776", "143813", "122814", "143847", "143857", "120916", "144173", "144375", "113905", "144377", "144378", "144379", "144385", "79271", "144462", "144463", "89667", "79953"],
        chatActive: false,
        chatType: "video",
        chatRoom: "",
        chatRecipientId: ""
    }

    static contextType = AuthContext;

    componentDidMount() {
        this.initSocketConnection();
        this.setupSocketListeners();
    }

    componentWillUnmount() {
        this.closeSocketConnection();
    }

    initSocketConnection() {
        const server = configData.SOCKET_API_LOUNGE + "/ests-house";
        this.socket = io.connect(server, { transports: ['websocket'], query: { token: this.context.token } });
        this.socket.on('connect', () => {
            this.socket.emit('sign-in', this.context.id);
        });
    }

    closeSocketConnection() {
        if (!this.socket.disconnected) {
            this.socket.disconnect();
        }
    }

    setupSocketListeners() {
        this.socket.on("sign-in", data => { this.onEnter(data); });
        this.socket.on("enter", data => { this.onPersonEnter(data); });
        this.socket.on("exit", data => { this.onPersonExit(data); });
        this.socket.on("contact-request-push", data => {
            this.setState({
                contactRequest: data,
                contactRequestActive: true
            })
        });
    }

    onSelectPage = (page) => {
        this.setState({ page: page })
    }

    onEnter = (persons) => {
        this.setState({ persons: persons })
        /* let newArray = [];
        if (persons !== undefined && persons.length > 0 ){
            for (let index = 0; index < persons.length; index++) {
                const element = persons[index];
                newArray.push(element)
            }
            this.setState({persons: newArray})
        } */
    }

    onPersonEnter = (newPerson) => {
        const arrayPersons = this.state.persons
        let alreadyExist = false;
        let indexDelete = 0;
        if (arrayPersons !== undefined && arrayPersons.length > 0) {
            if (newPerson.id !== undefined && newPerson.id !== null) {

                // check if already exists -> needs to delete first before adding
                for (let index = 0; index < arrayPersons.length; index++) {
                    const element = arrayPersons[index];
                    if (element.id === newPerson.id) {
                        indexDelete = index;
                        alreadyExist = true;
                        break;
                    }
                }

                if (alreadyExist) {
                    arrayPersons.splice(indexDelete, 1)
                }
                arrayPersons.unshift(newPerson);
                this.setState({ persons: arrayPersons })
            }
        } else {
            arrayPersons.unshift(newPerson);
            this.setState({ persons: arrayPersons })
        }
    }

    onPersonExit = (personId) => {
        const arrayPersons = this.state.persons
        if (arrayPersons !== undefined && arrayPersons.length > 0) {
            const newArray = arrayPersons.filter((el) => {
                return (el.id !== personId)
            })
            this.setState({ persons: newArray })
        }
    }

    onMainVoiceHandler = (id) => {
        this.setState({
            chatActive: true,
            chatType: "voice",
            chatRoom: this.state.id + '.' + this.context.id + '.' + id,
            chatRecipientId: id
        })
        const data = {
            room: this.state.id,
            id: this.context.id,
            contactId: id,
            type: "voice",
            roomAddress: this.state.chatRoom
        }
        this.socket.emit('contact-request', data); // join the room     
    }
    onMainVideoHandler = (id) => {
        this.setState({
            chatActive: true,
            chatType: "video",
            chatRoom: this.state.id + '.' + this.context.id + '.' + id,
            chatRecipientId: id
        })

        const data = {
            room: this.state.id,
            id: this.context.id,
            contactId: id,
            type: "video",
            roomAddress: this.state.chatRoom
        }
        this.socket.emit('contact-request', data); // join the room     
    }

    // CHAT CLOSE EVENTS ----------------------
    onCloseChatHandler = () => {
        this.setState({
            chatRoom: null,
            chatActive: false
        })
    }

    onVoiceSetHandler = () => {
        this.setState({
            chatActive: true,
            chatType: "voice"
        })
    }

    onVideoSetHandler = () => {
        this.setState({
            chatActive: true,
            chatType: "video"
        })
    }

    closeContactRequest = () => {
        this.setState({
            contactRequestActive: false
        })
    }

    acceptContactHandler = () => {
        this.setState({
            contactRequestActive: false,
            contactRequest: null,
            chatType: this.state.contactRequest.type,
            chatRoom: this.state.id + '.' + this.state.contactRequest.id + '.' + this.context.id,
            chatActive: true,
            chatMessages: []
        })
    }

    declineContactHandler = () => {
        this.setState({
            contactRequestActive: false,
            contactRequest: null
        })
    }

    render() {

        let content;
        let delegateClass = "networking-top-btn-container cursor-only";
        let socialClass = "networking-top-btn-container social-video cursor-only";
        let videoWallClass = "networking-top-btn-container social-video cursor-only";

        document.getElementById('root').style.backgroundImage = 'url("' + this.state.backgroundImage + '")';

        switch (this.state.page) {
            case 'delegates':
                content = <NetworkingDelegates persons={this.state.persons}
                    onVoice={this.onMainVoiceHandler}
                    onVideo={this.onMainVideoHandler} eventId={this.context.event_id}></NetworkingDelegates>
                delegateClass = "networking-top-btn-container selected"
                break;
            case 'social':
                content = <NetworkingSocialMedia eventId={this.context.event_id}></NetworkingSocialMedia>
                socialClass = "networking-top-btn-container social-video selected";
                break;
            case 'videowall':
                content = <NetworkingVideoWall eventId={this.context.event_id}></NetworkingVideoWall>
                videoWallClass = "networking-top-btn-container social-video selected";
                break;
            default:
                break;
        }


        let myChat
        if (this.state.chatActive) {

            if (this.state.chatType === "voice") myChat =
                <div className='backdrop-virtual-assistant'>
                    <div className='virtual-assistant-chat-container'>
                        <Video video={false} close={this.onCloseChatHandler} room={this.state.chatRoom} />
                    </div>
                </div>

            if (this.state.chatType === "video") myChat =
                <div className='backdrop-virtual-assistant'>
                    <div className='virtual-assistant-chat-container'>
                        <Video video={true} close={this.onCloseChatHandler} room={this.state.chatRoom} />
                    </div>
                </div>


        } else {
            myChat = null;
        }

        const myContactRequest = this.state.contactRequestActive ?
            <ContactRequest
                request={this.state.contactRequest}
                closeContactRequest={this.closeContactRequest}
                accept={this.acceptContactHandler}
                decline={this.declineContactHandler} />
            : null

        return (
            <React.Fragment>
                <div className="networking-main-area-container">

                    <div className={delegateClass} onClick={() => this.onSelectPage('delegates')} style={{width:`300px`}}>

                        <div className="networking-top-btn-wrapper" >

                            <div className="networking-top-btn-icon-delegates">
                                <img alt="" src="/img/networking-top-btn-icon-delegates.png" />
                            </div>

                            <div className="networking-top-btn-text-delegates">
                            ESTS HOUSE <br />13:50 - 14:30 h CET

                                

                        </div>

                        </div>

                    </div>
{/* 
                    <div className={socialClass} onClick={() => this.onSelectPage('social')}>

                        <div className="networking-top-btn-wrapper">

                            <div className="networking-top-btn-icon-social">
                                <img alt="" src="/img/networking-top-btn-icon-social-fb.png" />
                            </div>

                            <div className="networking-top-btn-icon-social-spacer">&nbsp;</div>

                            <div className="networking-top-btn-icon-social">
                                <img alt="" src="/img/networking-top-btn-icon-social-instagram.png" />
                            </div>

                            <div className="networking-top-btn-icon-social-spacer">&nbsp;</div>

                            <div className="networking-top-btn-icon-social">
                                <img alt="" src="/img/networking-top-btn-icon-social-twitter.png" />
                            </div>

                            <div className="networking-top-btn-text-social-video">
                                REDES SOCIALES
                        </div>

                        </div>

                    </div>

                    <div className={videoWallClass} onClick={() => this.onSelectPage('videowall')}>
                        <div className="networking-top-btn-wrapper">

                            <div className="networking-top-btn-icon-social">
                                <img alt="" src="/img/networking-top-btn-icon-video.png" />
                            </div>

                            <div className="networking-top-btn-text-social-video">
                                VIDEOS
                        </div>

                        </div>

                    </div>
 */}
                </div>

                <WithPermission userId={this.context.id} 
                    role={this.context.profile} 
                    objectType={"networking-lounge"} 
                    objectPermission={this.state.access} 
                    eventId={this.context.event_id}
                    isPublic={false}>
                    {content}
                </WithPermission>

                {myChat}
                {myContactRequest}

            </React.Fragment>
        );
    }

}

export default Networking;